import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LangContext";
import { api } from "../api/client";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { AUTH } from "../constants/testIds";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      if (data?.data?.preview_link) setPreview(data.data.preview_link);
    } catch (err) {
      // Response is intentionally identical whether or not the email exists.
      console.error("forgot-password failed", err);
    }
    setSent(true);
    setBusy(false);
  };

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <h1 className="font-[Outfit] text-4xl font-extrabold text-white tracking-tight">{t("auth.forgotTitle")}</h1>
        <p className="text-slate-400">{t("auth.forgotSubtitle")}</p>
      </div>
      {sent ? (
        <div className="space-y-3">
          <div data-testid={AUTH.forgotSuccess} className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-300">
            {t("auth.forgotSent")}
          </div>
          {preview && (
            <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-200 space-y-2">
              <p className="text-xs uppercase tracking-wider font-semibold">{t("auth.previewLabel")}</p>
              <a data-testid={AUTH.forgotPreviewLink} href={preview} className="block break-all font-mono text-xs text-white underline hover:text-amber-100">{preview}</a>
            </div>
          )}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label className="text-slate-300">{t("common.email")}</Label>
            <Input data-testid={AUTH.forgotEmail} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#1C202E] border-white/10 text-white h-11" />
          </div>
          <Button data-testid={AUTH.forgotSubmit} type="submit" disabled={busy} className="w-full h-11 bg-[#FF3B30] hover:bg-[#E02E24] text-white font-semibold">
            {busy ? t("common.loading") : t("auth.forgotSubmit")}
          </Button>
        </form>
      )}
      <div className="text-center text-sm text-slate-400">
        <Link to="/login" className="text-white font-semibold hover:text-[#FF3B30]">← {t("auth.loginLink")}</Link>
      </div>
    </div>
  );
}
